<script lang="ts" setup>
import Slide from './Slide.vue'
import G_block_ingredients from '@/components/Block/G_block_ingredients.vue'
import G_block_tips from '@/components/Block/G_block_tips.vue'
import G_block_slide from '@/components/Block/G_block_slide.vue'
import G_block_introduction_text from '@/components/Block/G_block_introduction_text.vue'
import G_block_tag from '@/components/Block/G_block_tag.vue'
import G_block_kol from '@/components/Block/G_block_kol.vue'
import type { IArticleRecipe } from '@/utils/types'

const props = defineProps({
  data: {
    type: Object as PropType<IArticleRecipe>,
    default: null
  }
})

const lines = (props.data.material_maintxt || '').split('\n')
const ingredientsData = ref({
  title: 'ingredients',
  text: `${props.data?.copies || ''} 人份`,
  lists: lines.map(line => {
    const parts = line.split(',')
    if (parts) {
      return {
        title: parts[0],
        text: parts[1]
      }
    } else {
      return {
        title: '',
        text: ''
      }
    }
  })
})
let intro = [
  {
    title: '廚具器材',
    text: props.data.tool_categories.map((x) => x.subject).join(', ')
  },
  {
    title: '調理方式',
    text: props.data.cooking_categories.map((x) => x.subject).join(', ')
  },
  {
    title: '食材',
    text: props.data.ingredient_categories.map((x) => x.subject).join(', ')
  },
]
if (!isEmpty(props.data.cuisine_categories)) {
  intro.push({
    title: '食譜類別',
    text: props.data.cuisine_categories.map((x) => x.subject).join(', ') + ' '
  })
}
if (!isEmpty(props.data?.memo_readytime)) {
  intro.push({
    title: '備料時間',
    text: `${props.data?.memo_readytime} `
  })
}
if (!isEmpty(props.data?.memo_cooktime)) {
  intro.push({
    title: '烹飪時間',
    text: props.data?.memo_cooktime
  })
}

const tipsData = ref({
  title: 'tips',
  text: '貼心提醒',
  content: props.data?.tips
})
</script>

<template>
  <section class="content">
    <Slide :intro="intro" :title="data.subject" :images="data.images" />
    <G_block_introduction_text :data="{ text: data.notes }" color="yellow" v-if="!isEmpty(data.notes)" />
    <G_block_ingredients :data="ingredientsData" v-if="lines.length > 0" />
    <Block :blocks="data.blocks" />
    <G_block_tips :data="tipsData" v-if="!isNullOrEmptyOrUndefined(data?.tips)" />
    <G_block_tag :tags="data?.tags" />
    <G_block_slide :products="data.products" />
    <G_block_kol :kol="data?.kol_info" />
  </section>
</template>

<style lang="scss" scoped></style>
